export const setting= {
  name: "Moebius",
  production: true,
  c_domain: '.moebius.tur.ar',
  authApiUrl: 'https://fusionpax-api.fusionpax.com/api/',
  appUrl: 'https://moebius.tur.ar', /// temporal debe ir moebius.tur.ar
  appBookingBackoffice: 'https://booking-bo.moebius.tur.ar/',
  appBookingUrl: 'https://booking-app.moebius.tur.ar/',
  apiBookingUrl: 'https://booking-api.moebius.tur.ar/api/v1/',
  apiOctopusUrl: 'https://octopus-api.fusionpax.com/api',
  routeUploadFile: 'https://fusionpax-api.fusionpax.com/storage/',
  apiStorageBooking: 'https://booking-api.moebius.tur.ar/storage/',
  apiAbacoUrl: 'https://abaco-api.moebius.tur.ar/api/v1/',
  clientIdPaypal:"EHd6g3jaGD82NlUcn09stPzBNEgVYQaSUge13EY8wMcbnXHXS_gAkGuEATvJ9qsCjRMCffvwzFVDDEH6", 
  client_id:  'QA7kxgtk2eKrJDwK',
  client_secret: 'mL6SNux7pD8p8FoQRneYz0BP9NI9AP1519938479',
  defauldTimeBooking: 10,
  ApiUser : "MOEV254135",
  ApiKey  : "7245M841O01EV25",
  abacoApiUser: "devUser",
  abacoApiKey: "DevUs2024#?13579",
  // Square payment platform
  squareLocationId: "EAAAlwG8UJT4eXk6_nuRU2-Sldiop1ADOrNsolhwXIKDV2TctNLqlLUgPxvKvhSL",
  squareApplicationId: "sandbox-sq0idb-ihglSG6-anE9432sChG_lA",
  booking_api_user: "PRODBOOKINGAPP1113",
  booking_api_key: "829a7597128a5e177efffca73f480e5e76ed7690577a3fcc99127843d14c8c09",
  app_names: {
  	booking_backoffice: 'backoffice',
  	zoco: 'zoco',
  	booking: 'booking',
  	abaco: 'abaco',
  	chat: 'chat',
  	octopus: 'octopus'
  },
  ActivatedGuard: true
};
